import { hostProtocol } from '@utils/localization'

const canonicalUrl = (host, query): string => {
  let path:string = `${hostProtocol(host)}${query}`

  return path
}

export default canonicalUrl